import './NoData.css';

const NoData = ({text}) => {

	return (
		<div className='container'>
			<div className="noData">
				<div className="col-12">
					<p>{text}</p>
				</div>
			</div>
		</div>
	);
}

export default NoData;